import { Component } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthService } from 'src/app/core/auth.service';
import { TitleService } from 'src/app/services/title.service';
import { SidebarService } from 'src/app/components/sidebar/sidebar.service';
import { SessionService } from 'src/app/core/session.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  title$: Observable<string>;

  constructor(
    public authService: AuthService,
    public sidebarService: SidebarService,
    public titleService: TitleService,
    public sessionService: SessionService
  ) {}
}
